import './darkTheme.scss';

const DarkTheme = () => <></>;

export default DarkTheme;
